import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsDbattrsService } from './edit-dialogs-dbattrs.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-dbattrs',
  templateUrl: './edit-dialogs-dbattrs.component.html',
  styleUrls: ['./edit-dialogs-dbattrs.component.scss']
})
export class EditDialogsDbattrsComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsDbattrsService: EditDialogsDbattrsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsDbattrsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsDbattrsService.build(); }

  ngOnInit() {
    this.editDialogsDbattrsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Dbattr
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsDbattrsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del dbattr está ausente
      // -1: El número del dbattr ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorDbattrs('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorDbattrs('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog dbattrs
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let dbattr = this.editDialogsDbattrsService.dbattrs;
    let original = this.editDialogsDbattrsService.originalDbattrs;
    return this.editDialogsDbattrsService.compare(dbattr, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorDbattrs(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
